var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chart-2",
    "data-name": "Chart",
    d: "M5.641,20a5.478,5.478,0,0,1-4.092-1.642A6.024,6.024,0,0,1,0,14.107V5.893A6.018,6.018,0,0,1,1.552,1.644,5.475,5.475,0,0,1,5.641,0h8.717a5.478,5.478,0,0,1,4.092,1.643A6.024,6.024,0,0,1,20,5.893v8.213a6.024,6.024,0,0,1-1.549,4.251A5.478,5.478,0,0,1,14.359,20ZM1.395,5.893v8.213c0,2.732,1.667,4.5,4.246,4.5h8.717c2.579,0,4.246-1.766,4.246-4.5V5.893c0-2.732-1.667-4.5-4.246-4.5H5.641C3.062,1.395,1.395,3.161,1.395,5.893ZM13.614,14.8l-.006-.095V11.7A.7.7,0,0,1,15,11.6L15,11.7v3.01a.7.7,0,0,1-1.389.095Zm-4.271,0-.006-.095V5.274a.7.7,0,0,1,1.39-.1l.006.1v9.435a.7.7,0,0,1-1.39.095ZM5,14.8,5,14.709V8.327a.7.7,0,0,1,1.389-.095l.006.095v6.382A.7.7,0,0,1,5,14.8Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemReportsIcon);
export default __webpack_public_path__ + "static/media/menu-item-reports-icon.8ae49ef5fc86ae18d4cb087f49278045.svg";
export { ForwardRef as ReactComponent };